import { render } from "./FlightConfirmationView.vue?vue&type=template&id=4c706c26"
import script from "./FlightConfirmationView.vue?vue&type=script&lang=js"
export * from "./FlightConfirmationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__